import type { RoomReportInfoDataItem, RoomReportInfoMenu } from '~/features/room/report/types'

export const ROOM_REPORT_INFO_MENU_FIELD_MAP_DATA_ITEM_FIELD: Record<
  keyof RoomReportInfoMenu,
  keyof Omit<RoomReportInfoDataItem, 'bizdate' | 'unfollowed_fans_num'>
> = {
  total_live_duration: 'live_duration',
  new_fans_num: 'new_fans_num',
  total_listener_duration_avg: 'listener_duration_avg',
  listener_duration_more_than_five_minutes_ratio: 'listener_duration_more_than_five_minutes_ratio',
}
